import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IStripeKeys} from "../../models/IStripeKeys";
import {IStripeKeyResponse} from "../../models/Payment";
import {getStripeKey} from "./ActionStripeKeys";

interface IStripeKeysState {
    gateway: IStripeKeys
    isLoading: boolean,
    error: string,
}

const initialStripeKeyState: IStripeKeysState = {
    gateway: {
        customerId: "",
        publicKey: "",
    },
    isLoading: false,
    error: ""
}

const stripeKeysSlice = createSlice({
    name: "stripeKeys",
    initialState: initialStripeKeyState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStripeKey.fulfilled, (state, action: PayloadAction<IStripeKeyResponse>) => {
                state.gateway = {
                    customerId: action.payload.data.customerId,
                    publicKey: action.payload.data.gateway,
                };
                state.error = "";
                state.isLoading = false;
            })
            .addCase(getStripeKey.rejected, (state, action: PayloadAction<any>) => {
                state.error = action.payload;
                state.isLoading = false;
            })
            .addCase(getStripeKey.pending, (state) => {
                state.isLoading = true;
            });
    },
});

export default stripeKeysSlice.reducer;